package io.horion.cv.models

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue

class Responsability (
    val id: String,
    responsability: String = ""
) {
    var responsability by mutableStateOf(responsability)
}